import { useNavigate, useSearchParams, Navigate } from 'react-router-dom';
import { PropertiesPage } from './PropertiesPage';
import type { PropertiesTab } from '../types/properties.types';
import { usePermissions } from '@practium/features/permissions';
import { useForBinding } from '@practium/features/forBinding';

export const PropertiesPageClient = () => {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const { isForBinding } = useForBinding();
	const { abilities } = usePermissions();

	const propertyId = searchParams.get('id');

	const subject = isForBinding ? 'farmers-props' : 'props';
	const canRead = abilities.can('read', subject);
	const permissions = {
		canCreate: abilities.can('create', subject),
		canEdit: abilities.can('update', subject),
		canDelete: abilities.can('delete', subject),
	};

	const handleAddNew = (tab: PropertiesTab) => {
		if (tab === 'properties') {
			navigate('/propriedades/novo?type=properties');
			return;
		}
		navigate(`/propriedades/novo?type=${tab}&propId=${propertyId}`);
	};

	const handleSelectProperty = (id: string) => {
		navigate(`/propriedades?id=${id}`);
	};

	const handleBack = () => {
		navigate('/propriedades');
	};

	const handleViewItem = (tab: PropertiesTab, id: string) => {
		navigate(`/propriedades/ver?type=${tab}&id=${id}`);
	};

	if (!canRead) return <Navigate to="/" replace />;

	return (
		<PropertiesPage
			permissions={permissions}
			onAddNew={handleAddNew}
			onSelectProperty={handleSelectProperty}
			onViewItem={handleViewItem}
			onBack={handleBack}
		/>
	);
};
